export const resources = {
  resourcesFolderInfoText: 'Failas(-ai)',
  resourcesItemInfoLastUpdText: 'Atnaujinta',
  resourcesItemInfoUploadedText: 'Įkelta',
  resourcesSearchInputText: 'Ieškoti',
  resourcesUserActionSheetOptionTitle: 'Kopijuoti nuorodą',
  resourcesActionCopiedAlertText: 'Nuoroda nukopijuota!',
  resourcesOwnersCurtainEditOptionText: 'Redaguoti pavadinimą',
  resourcesOwnersCurtainDeleteOptionText: 'Ištrinti',
  resourcesOwnerCurtainHideOptionText: 'Slėpti (neaktyvus)',
  resourcesEditPopupTitle: 'Redaguoti pavadinimą',
  resourcesEditPopupResetButtonTitle: 'Atstatyti',
  resourcesEditPopupApplyButtonTitle: 'Taikyti',
  resourcesItemEditedAlertText: 'Elementas sėkmingai atnaujintas!',
  resourcesHidePopupTitle: 'Slėpti',
  resourcesHidePopupText: 'Slėpti šį elementą?',
  resourcesHidePopupCancelButtonTitle: 'Atšaukti',
  resourcesHidePopupConfirmButtonTitle: 'Patvirtinti',
  resourcesDeletePopupTitle: 'Ištrinti',
  resourcesDeletePopupText: 'Ištrinti šį elementą?',
  resourcesDeletePopupCancelButtonTitle: 'Atšaukti',
  resourcesDeletePopupConfirmButtonTitle: 'Patvirtinti',
  resourcesItemDeletedAlertText: 'Elementas sėkmingai ištrintas!',
  resourceDetailsLinkText: 'Tai išorinis URL, atsidarys naujame lange. Atidaryti?',
  resourceDetailsLinkOpenButtonTitle: 'Atidaryti',
  resourceDetailsLinkOpenAgainButtonTitle: 'Atidaryti dar kartą',
  resourceDetailsLinkCopyURLButtonTitle: 'Kopijuoti tikslinį URL',
  resourceDetailsLinkCopiedURLAlertText: 'URL nukopijuotas!',
  resurceDetailsLinkCurtainOptionCopyText: 'Kopijuoti nuorodą',
  resourceDetailsFileInfoLastUpdText: 'Atnaujinta',
  resourceDetailsFileInfoUploadText: 'Įkelta',
  resourceDetailsFileSaveButtonTitle: 'Atidaryti',
  resourceDetailsFileCopyButtonTitle: 'Kopijuoti nuorodą',
  resourcesOwnersCurtainCopyOptionText: 'Kopijuoti nuorodą',
  resourceDetailsFileLoadingText: 'Atsisiunčiama...',
  resourceDetailsImageCurtainCopyOptionText: 'Kopijuoti nuorodą',
  resourceDetailsImageCurtainDownloadOptionText: 'Atsisiųsti',
  resourceFolder: 'Aplankas',
  resourceAdded: 'Pridėta'
}
